export default "__VITE_ASSET__BYs4RMqF__"